import React, { Suspense, useState, useEffect, useContext } from "react";
import { Routes, Route, Link } from "react-router-dom";
import InstallPWA from "./pages/Installation/index";
import { Context } from "./utils/Context";
import swDev from "./swDev";

//material UI
import {
  Grid,
  Box,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material";

//icons
import RestoreIcon from "@mui/icons-material/Restore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

//css
import "./App.css";

//screens
//import SplashScreen from "./pages/Splash";
import HomeScreen from "./pages/Home";
import ResourcesScreen from "./pages/Resources";
import ContactScreen from "./pages/Contacts";
import GenderHomeScreen from "./pages/Genderometer/";
import WonQuizScreen from "./pages/Quiz/won";
import LostQuizScreen from "./pages/Quiz/lost";
import ErrorScreen from "./pages/404/error";
import AboutScreen from "./pages/About";
import QuestionScreen from "./pages/Quiz/question";
import ReasonScreen from "./pages/Quiz/response";
import GenderResponseScreen from "./pages/Genderometer/responseEx";

export default function App() {
  const [value, setValue] = React.useState(5);
  const [dialogOpen, setDialogOpen] = useState(true);
  const {
    installed,
    setInstalled,
    latitude,
    setLatitude,
    longitude,
    setLongitude,
    hasBeenPromptedToInstall,
    setHasBeenPromptedToInstall,
  } = useContext(Context);

  swDev({ latitude, setLatitude, longitude, setLongitude });

  const checkIfAppIsInstalled = async () => {
    try {
      const relatedApps = await navigator.getInstalledRelatedApps();

      // Check if your PWA is in the list of related apps
      const isAppInstalled = relatedApps.some(
        (app) => app.id === "mygender.uc.pt"
      );

      return isAppInstalled;
    } catch (error) {
      console.error("Error checking installed related apps:", error);
      return false;
    }
  };

  useEffect(() => {
    const handleCheckInstalledApp = async () => {
      const isAppInstalled = await checkIfAppIsInstalled();

      if (isAppInstalled) {
        setInstalled(true);
      }
    };

    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone
    ) {
      setInstalled(true);
    }

    if ("getInstalledRelatedApps" in navigator) {
      handleCheckInstalledApp();
    }

    if ("serviceWorker" in navigator) {
      if (navigator.serviceWorker.controller) {
        setInstalled(true);
      }
    }
  }, [setInstalled]);

  const handleDialogClose = () => {
    setHasBeenPromptedToInstall(true);
    setDialogOpen(false);
  };

  return (
    <main>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={{ xs: 2, md: 3 }}></Grid>

        <Paper
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
          }}
          elevation={3}
        >
          <BottomNavigation
            showLabels
            value={value}
            sx={{
              borderTop: "8px solid #EDE838",
              backgroundColor: "#000000",
              "& .MuiBottomNavigationAction-root, .Mui-selected, svg": {
                color: "#ffffff",
              },
              "& .Mui-selected, .Mui-selected > svg": {
                color: "#EDE838",
                //animation: "300s myEffect infinite",
              },
            }}
            onChange={(event, newValue) => {
              //0 - home, 1 - recursos, 2 - contacto, 3 - quiz
              setValue(newValue);
            }}
          >
            <BottomNavigationAction
              component={Link}
              to="/about"
              label="MyGender"
              icon={<InfoOutlinedIcon />}
              sx={{
                fontFamily: "Helvetica, Arial, sans-serif",
                fontSize: "0.75em",
                fontWeight: "700",
                lineHeight: "100%",
              }}
            />
            <BottomNavigationAction
              component={Link}
              to="/resources"
              label="Recursos"
              icon={<RestoreIcon />}
              sx={{
                fontFamily: "Helvetica, Arial, sans-serif",
                fontSize: "0.75em",
                fontWeight: "700",
                lineHeight: "100%",
              }}
            />
            <BottomNavigationAction
              component={Link}
              to="/contacts"
              label="Contacto"
              icon={<AlternateEmailIcon />}
              sx={{
                fontFamily: "Helvetica, Arial, sans-serif",
                fontSize: "0.75em",
                fontWeight: "700",
                lineHeight: "100%",
              }}
            />
            <BottomNavigationAction
              component={Link}
              to="/genderometer"
              label="Quiz"
              icon={<HelpOutlineIcon />}
              sx={{
                fontFamily: "Helvetica, Arial, sans-serif",
                fontSize: "0.75em",
                fontWeight: "700",
                lineHeight: "100%",
              }}
            />
          </BottomNavigation>
        </Paper>
        {!(installed || hasBeenPromptedToInstall) && (
          <InstallPWA open={dialogOpen} handleClose={handleDialogClose} />
        )}
      </Box>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/about" element={<AboutScreen />}></Route>
          <Route path="/resources" element={<ResourcesScreen />}></Route>
          <Route path="/contacts" element={<ContactScreen />}></Route>
          <Route path="/genderometer" element={<GenderHomeScreen />}></Route>
          <Route path="/genderonext" element={<GenderResponseScreen />}></Route>
          <Route path="/win" element={<WonQuizScreen />}></Route>
          <Route path="/lost" element={<LostQuizScreen />}></Route>
          <Route path="/question" element={<QuestionScreen />}></Route>
          <Route path="/response/:id" element={<ReasonScreen />}></Route>
          <Route path="/" element={<HomeScreen />}></Route>
          <Route path="*" element={<ErrorScreen />}></Route>
        </Routes>
      </Suspense>
    </main>
  );
}
